import type { Uuid } from "@shared/api";

/**
 * Куда вставлять в список, из которого перетаскиваемый уже вынут.
 *
 * Черта места считается по списку, который на экране, — а он вместе с самим
 * перетаскиваемым. Вставляем же в список без него, и пока его тащат вниз, всё,
 * что ниже черты, уже сдвинулось на единицу вверх. Отсюда «улетает на позицию
 * дальше»: с первого места на второе выходило третье.
 *
 * Вверх это не проявлялось вовсе — там перетаскиваемый ниже черты и на индексы
 * над ней не влияет. Поэтому и заметили только половину поломки.
 *
 * `order` — порядок на экране, вместе с перетаскиваемым; его там может и не
 * быть, если канал переносят из другой категории.
 */
export function insertionAt(order: Uuid[], moved: Uuid, marked: number): number {
  const from = order.indexOf(moved);
  const shifted = from >= 0 && from < marked ? marked - 1 : marked;

  // Мест ровно столько, сколько останется соседей.
  const room = order.length - (from >= 0 ? 1 : 0);

  return Math.min(Math.max(shifted, 0), room);
}
